module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/mc-082fc1558b4cf726b6130f863131d635.svg";